import Base from './base';

export default class Quota extends Base {
  constructor(item, url) {
    super(item, url);

    this.participant_count = item.participant_count;
    this.nomination_id = item.nomination_id;
    this.event_id = item.event_id;
    this.organizer_id = item.organizer_id;
    this.group_id = item.group_id;
  }
}
